export default [
  {
    title: 'จัดการข้อมูล สไลด์',
    route: 'slideManagement',
    icon: 'UserIcon',
    action: 'all',
    resource: 'admin',
  },
]
